import { render, staticRenderFns } from "./QuizBox.vue?vue&type=template&id=57dfc72b&scoped=true&"
import script from "./QuizBox.vue?vue&type=script&lang=js&"
export * from "./QuizBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dfc72b",
  null
  
)

export default component.exports